<template>
  <div>
      <div class="open-form" data-toggle="modal" data-target="#contact-form">
        <img style="" height="50" src="/../img/Icono_Contacto_Blanco.png">
      </div>

      <!-- Modal -->
      <div class="modal right fade" id="contact-form" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>

            <div class="modal-body">
              <div class="frame">
                <h4 class="text-white">¡Hagamos un trato!</h4>
                <form @submit.prevent="submit">
                  <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                    <label class="form__label">Nombre *</label>
                    <input class="form__input form-control" v-model.trim="name"/>
                  </div>
                  <div class="form-group">
                    <label for="email">Email *</label>
                    <input type="email" class="form-control" v-model.trim="email">
                  </div>
                  <div class="form-group">
                    <label for="phone">Telefono</label>
                    <input type="text" class="form-control" v-model.trim="phone">
                  </div>
                  <div class="form-group">
                    <label for="message">Mensaje *</label>
                    <textarea rows="7" class="form-control" v-model.trim="message"></textarea>
                  </div>
                  <p>( * ) Campos obligatorios</p>
                  <button class="btn btn-secondary" type="submit" :disabled="submitStatus === 'PENDING'">Enviar!</button>
                  <p class="typo__p" v-if="submitStatus === 'OK'"></p>
                  <p class="typo__p" v-if="submitStatus === 'ERROR'"></p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">Enviando</p>
                  <!-- <button type="submit" class="btn btn-primary">Enviar</button> -->
                </form>

                <div class="col-xl-12">
                    <h4 class="text-dark">Dirección:</h4>
                    <p>Eje 7 - A Sur (Gral. Emiliano Zapata) 187 bis. Colonia Portales, Delegación Benito Juárez, CP 03300.</p>

                    <h4 class="text-dark">Telefono:</h4>
                    <p>41-55-77-00 y 41-55-77-01</p>
                </div>
              </div>
            </div>

          </div><!-- modal-content -->
        </div><!-- modal-dialog -->
      </div><!-- modal -->
  </div>
</template>

<script>
  import { required, minLength, between, email } from 'vuelidate/lib/validators'
  export default {
    name: 'Contact',
    data() {
      return {
        name: null,
        email: null,
        phone: null,
        message: null,
        submitStatus: null
      }
    },
    validations: {
      name: {
        required,
        minLength: minLength(4)
      },
      email: {
        required,
        email
      },
      message: {
        required
      }
    },
    methods: {
      setName(value) {
        this.name = value
        this.$v.name.$touch()
      },
      setEmail(value) {
        this.email = value
        this.$v.email.$touch()
      },
      setPhone(value) {
        this.phone = value
        this.$v.phone.$touch()
      },
      setMessage(value) {
        this.message = value
        this.$v.message.$touch()
      },
      submit() {
        console.log('submit!')
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = 'ERROR'
          this.$swal('Error', 'Llene bien el formulario', 'error');
        } else {
          // do your submit logic here
          this.submitStatus = 'PENDING'
          this.$http.post('/contact', {
              name: this.name,
              email: this.email,
              phone: this.phone,
              message: this.message,
            }
          ).then(response => {
            this.$swal('Gracias', 'Se ha enviado tu información', 'success');
            this.submitStatus = null
            this.name = null
            this.email = null
            this.phone = null
            this.message = null
          }, response => {
            this.$swal('Error', 'Se provoco un error intente de nuevo', 'error');
            this.submitStatus = null
          });
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.open-form {
  cursor: pointer;
  position: fixed;
  top: 80px;
  right: 0;
  background-color: #cf312d;
  height: 55px;
  z-index: 1050;
  -webkit-box-shadow: 0px 2px 45px 0px rgba(176,176,176,1);
  -moz-box-shadow: 0px 2px 45px 0px rgba(176,176,176,1);
  box-shadow: 0px 2px 45px 0px rgba(176,176,176,1);
}
.open-form img {
  background-color: #cf312d;
  padding: 5px;
}
.frame {
  padding: 15px;
  border: 1px solid #fff;
  min-height: calc(100vh - 86px);
  margin: auto;
  overflow-y: auto;
}
.modal.right .modal-dialog {
    position: fixed;
    margin: auto;
    width: 320px;
    height: 100%;
    -webkit-transform: translate3d(0%, 0, 0);
        -ms-transform: translate3d(0%, 0, 0);
         -o-transform: translate3d(0%, 0, 0);
            transform: translate3d(0%, 0, 0);
  }

  .modal.right .modal-content {
    height: 100%;
    overflow-y: auto;
  }

  .modal.right .modal-body {
    padding: 15px 15px 15px;
    text-align: center;
  }

/*Right*/
  .modal.right.fade .modal-dialog {
    right: 0;
    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
       -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
         -o-transition: opacity 0.3s linear, right 0.3s ease-out;
            transition: opacity 0.3s linear, right 0.3s ease-out;
  }

  .modal.right.fade.in .modal-dialog {
    right: 0;
  }

/* ----- MODAL STYLE ----- */
  .modal-content {
    border-radius: 0;
    border: none;
    background-color: #c82b29;
    color: #fff;
  }

  .modal-header {
    color: #fff;
    display: block;
    border-bottom: 0;
    background-color: #c82b29;
  }
  .modal-header .close {
    color: #fff;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/vue/components/contact/Contact.vue